import { LINE, RADAR } from "src/components/Charts/types";
import { defaultEchartOption } from "./defaultEchartOption";

/**
 * 
 * @param {string} chartType - Tipo do gráfico {BAR | TYPEN}
 * @param {object} theme - Objeto de tema da aplicação
 * @param {boolean} legendEnabled - True caso a legenda deva aparecer no componente de preview, false se não.
 * @returns Objeto de legenda do componente de preview do gráfico.
 */
export function getLegend(chartType, theme, legendEnabled = false) {
  let pickedLegends = defaultEchartOption.legend;

  if (chartType === LINE) {
    pickedLegends = {
      data: ['LEGENDA', 'LEGENDA '],
      top: '8%',
    };    
  } else if (chartType === RADAR) {
    pickedLegends = {
      data: ['LEGENDA', 'LEGENDA '],
      top: '3%',
    }
  }

  return {
    ...pickedLegends,
    show: legendEnabled,
    textStyle: { color: theme.title === 'dark' ? theme.colors.charts.legend.color : '#32383D' },
  };
}